import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {API_URL} from './token.service';

import 'rxjs/add/operator/filter';

@Injectable()
export class _RuleHedgeRatioService{

  constructor(private http: HttpClient){ }

  getHedgeRatios(ruleType){
    return this.http.get<any[]>(`${API_URL}/rule-hedge-ratios/rule-type/` + ruleType).toPromise().then(function(response){
      var hedgeRatios = response;
      for(var i = 0;i<hedgeRatios.length;i++){
        if(hedgeRatios[i].entityType == null){
          hedgeRatios[i].entityType = 'all';
          hedgeRatios[i].entityId = 0;
        }
        if(hedgeRatios[i].baseCurrency == null){
          hedgeRatios[i].baseCurrency = "(All)";
        }
        if(hedgeRatios[i].localCurrency == null){
          hedgeRatios[i].localCurrency = "(All)";
        }
      }
      return hedgeRatios;
    });
  }

  createHedgeRatio(ruleHedgeRatio){
    if(ruleHedgeRatio.entityType == 'all'){
      ruleHedgeRatio.entityType = null;
      ruleHedgeRatio.entityId = null;
    }
    if(ruleHedgeRatio.baseCurrency == "(All)"){
      ruleHedgeRatio.baseCurrency = null;
    }
    if(ruleHedgeRatio.localCurrency == "(All)"){
      ruleHedgeRatio.localCurrency = null;
    }
    if(ruleHedgeRatio.alternateCurrency == ""){
      ruleHedgeRatio.alternateCurrency = null;
    }
    return this.http.post(`${API_URL}/rule-hedge-ratios`, [ ruleHedgeRatio ]);
  }

  updateHedgeRatio(ruleHedgeRatio){
    if(ruleHedgeRatio.entityType == 'all'){
      ruleHedgeRatio.entityType = null;
      ruleHedgeRatio.entityId = null;
    }
    if(ruleHedgeRatio.baseCurrency == "(All)"){
      ruleHedgeRatio.baseCurrency = null;
    }
    if(ruleHedgeRatio.localCurrency == "(All)"){
      ruleHedgeRatio.localCurrency = null;
    }
    if(ruleHedgeRatio.alternateCurrency == ""){
      ruleHedgeRatio.alternateCurrency = null;
    }
    return this.http.put(`${API_URL}/rule-hedge-ratios`, [ ruleHedgeRatio ]);
  }

  deleteHedgeRatio(ruleHedgeRatioId){
    return this.http.delete(`${API_URL}/rule-hedge-ratios/` + ruleHedgeRatioId);
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/services/ruleHedgeRatio.service.ts